import { render, staticRenderFns } from "./AccountsSalesAfpsStat.vue?vue&type=template&id=3bc45504&"
import script from "./AccountsSalesAfpsStat.vue?vue&type=script&lang=js&"
export * from "./AccountsSalesAfpsStat.vue?vue&type=script&lang=js&"
import style0 from "./AccountsSalesAfpsStat.vue?vue&type=style&index=0&id=3bc45504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports